<app-header></app-header>
<div class="content small-head">
  <!-- <mat-card class="info-card">
    
  </mat-card> -->
    <ngx-extended-pdf-viewer
    #pdfViewer
      [src]="fileUrl"
      [page]="currentPage"
      useBrowserLocale="true"
      height="83vh"
      (pagesLoaded)="onPagesLoaded($event)"
      (pageChange)="onPageChange($event)"
      [contextMenuAllowed]="false"
      [showPrintButton]="false"
      [showHandToolButton]="false"
      [showSidebarButton]="true"
      [showSpreadButton]="false"
      [showSecondaryToolbarButton]="false"
      [showPagingButtons]="true"
      [showOpenFileButton]="false"
      [showDownloadButton]="false"
      [showRotateButton]="false"
      minZoom="0.5"
      maxZoom="2"
      minifiedJSLibraries="true">
    </ngx-extended-pdf-viewer>
    <div class="btn-next">
      <button mat-raised-button id="docNextStep" color="primary" [disabled]="isDisabled" (click)=onClick()>{{'NextBtn' | translate}}</button>
    </div>

</div>